export default {
  productIdSelected: null,
  bioassaySelected: null,
};
